import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { Box, Grid, Typography } from '@mui/material'

import { TextInput, SelectInput, BasicTable, FileUploaderInput } from '../../../../ui'
import { COMPANY_FORM_CONFIG, INSPECTORES_LIST_CONFIG } from '../../constants'
import { CompanyLogo } from './company-logo.component'
import { IpIBANDisplayer } from './ip-iban-displayer.component'
import { PORequests } from './po-requests.component'
import { ReviewsBtn } from '../reviews/review.btn.component'


export const CompanyForm = ({ model = {}, isPrimaryCompany = false, getEIData }) => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const permissions = useSelector((state) => state.global.permissions)

  const showLeftContent = model.captadora || !isPrimaryCompany
  const formState = {
    ...model,
    acepta_financiacion: model['acepta_financiacion'] ? '01' : '00',
    publica: model['publica'] ? '01' : '00',
  }
  const inputProps = { formState, combos, intl }
  const isPrescriptor = Boolean(formState?.prescriptor)
  return (
    <form>
      <Box p={3} display="flex">
        <Grid container spacing={3}>
          {showLeftContent ? (
            <Grid size={{ sm: 12, md: 4 }}>
              <CompanyLogo
                {...{
                  hasPublicProfile: formState.publica,
                  isPrimaryCompany,
                  model: formState,
                }}
              />
            </Grid>
          ) : null}
          <Grid size={{ sm: 12, md: showLeftContent ? 8 : 12 }}>
            <Grid container spacing={3}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextInput {...COMPANY_FORM_CONFIG(inputProps).NOMBRE} />
              </Grid>
              {isPrimaryCompany ? (
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextInput {...COMPANY_FORM_CONFIG(inputProps).NIF} />
                </Grid>
              ) : null}
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextInput {...COMPANY_FORM_CONFIG(inputProps).RAZON} />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextInput {...COMPANY_FORM_CONFIG(inputProps).WEB} />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextInput {...COMPANY_FORM_CONFIG(inputProps).DIRECCION} />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextInput {...COMPANY_FORM_CONFIG(inputProps).COD_POSTAL} />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextInput {...COMPANY_FORM_CONFIG(inputProps).EMAIL} />
              </Grid>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextInput {...COMPANY_FORM_CONFIG(inputProps).TELEFONO} />
              </Grid>
              {isPrescriptor ? (
                <Grid size={{ xs: 12, sm: 6 }}>
                  <TextInput {...COMPANY_FORM_CONFIG(inputProps).TIPO_ACTIVIDAD} />
                </Grid>
              ) : null}
              {formState.captadora || !isPrimaryCompany ? (
                <>
                  {isPrimaryCompany ? (
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextInput {...COMPANY_FORM_CONFIG(inputProps).PUBLICA} />
                    </Grid>
                  ) : null}
                  {isPrimaryCompany && formState.publica === '01' ? (
                    <>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <SelectInput {...COMPANY_FORM_CONFIG(inputProps).ACEPTA_F} />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <TextInput {...COMPANY_FORM_CONFIG(inputProps).COD_ENTIDAD_FINANCIERA} />
                      </Grid>
                    </>
                  ) : null}
                  <Grid size={12}>
                    <TextInput {...COMPANY_FORM_CONFIG(inputProps).DESCRIPCION} />
                  </Grid>
                </>
              ) : null}
              {isPrimaryCompany && formState.grabadora ? (
                <>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <SelectInput {...COMPANY_FORM_CONFIG(inputProps).CATEGORIA} />
                  </Grid>
                  <Grid size={12}>
                    <IpIBANDisplayer {...{ inputProps, getEIData }} />
                  </Grid>
                </>
              ) : null}


              {formState.captadora || !isPrimaryCompany ? (
                <>
                  <Grid size={12} style={{ margin: '15px 0 10px 0' }}>
                    <Typography variant="h6" color="primary">
                      Datos de Registro para Oferta Pública
                    </Typography>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextInput {...COMPANY_FORM_CONFIG(inputProps).RESPONSABLE_LEGAL} />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <TextInput {...COMPANY_FORM_CONFIG(inputProps).NIF_RESPONSABLE_LEGAL} />
                  </Grid>
                  {isPrimaryCompany ? (
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <TextInput {...COMPANY_FORM_CONFIG(inputProps).CODIGO_REG_INDUSTRIAL} />
                    </Grid>
                  ) : null}
                  {!isPrimaryCompany ? (
                    <>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <TextInput {...COMPANY_FORM_CONFIG(inputProps).IBAN_OP} />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <FileUploaderInput
                          {...COMPANY_FORM_CONFIG(inputProps).CERTIFICADO_BANCARIO_IBAN_SWIFT}
                        />
                      </Grid>
                    </>
                  ) : null}
                </>
              ) : null}
              <Grid size={12} style={{ margin: '15px 0 10px 0' }}>
                {!isPrimaryCompany ? (
                  <PORequests
                    company={model}
                    data={formState.ofertas_publicas}
                    canNavigate={permissions.gestion_adhesiones_op}
                  />
                ) : null}
              </Grid>
              <Grid size={12}>
                {!isPrimaryCompany && formState.total_valoraciones > 0 ? (
                  <ReviewsBtn formState={formState} isPrimaryCompany={isPrimaryCompany} />
                ) : null}
              </Grid>
              {isPrimaryCompany && formState.inspectores?.length ? (
                <Grid size={12}>
                  <Typography variant="h6" paragraph>
                    Listado de instaladores
                  </Typography>
                  <BasicTable config={INSPECTORES_LIST_CONFIG} data={formState.inspectores} />
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </form>
  )
}
